module.exports = __webpack_public_path__ + "img/link.9409cf33.svg";